import { Typography } from "@mui/material";
import React from "react";

import { isAdmin } from "../../../utils/constants";
import CompanyInfoForm from "./CompanyInfoForm";
import BrandingLogo from "./BrandingLogo";
import LDAPSettingsBindCred from "./LDAPSettingsBindCred";
import { useTenant } from "../../../reactQuery/tenant";
import Loader from "../../../components/Loader";
import { useResponsive } from "../../../hooks/useResponsive";
import WorkingHours from "./WorkingHours";
import "./systemSetting.scss";
import GoogleAuthLogin from "./GoogleAuthLogin";
import PlannerSettings from "./PlannerSettings";
import IntegrationsSettings from "./IntegrationsSettings";
import { normalizeTenantSettings } from "./utils/systemSettingUtils";

function SystemSettingComp() {
  const { data, isLoading } = useTenant();
  const { responseData = null } = data?.data?.data || {};
  const isMobile = useResponsive("down", "md");
  const settings = normalizeTenantSettings(responseData);

  return (
    <>
      {isAdmin() ? (
        <>
          <Typography className={`admin-header-heading ${isMobile && "mt-2"}`}>
            System Setting
          </Typography>
          {isLoading ? (
            <div className="loader-center">
              <Loader color={"black"} />
            </div>
          ) : (
            <>
              <CompanyInfoForm initialData={settings.companyInfo} />
              <BrandingLogo />
              <WorkingHours initialData={settings.workingHours} />
              <PlannerSettings initialData={settings.plannerSettings} />
              <GoogleAuthLogin initialData={settings.googleAuth} />
              <LDAPSettingsBindCred initialData={settings.ldapSettings} />
              <IntegrationsSettings
                rocketchat_shared_secret={
                  settings.integrations?.rocketchat_shared_secret
                }
                slack_bot_token={settings.integrations?.slack_bot_token}
              />
              <div className="mt-4 p-4"></div>
            </>
          )}
        </>
      ) : (
        <div className="loader-center">
          <div className="weight-700 size-16 text-color ">
            You can't access this page
          </div>
        </div>
      )}
    </>
  );
}

export default React.memo(SystemSettingComp);
